import classNames from "classnames";
import React from "react";
import { NOTIFICATIONS_TAB_STYLES_TYPES } from "../../../../../../../redux/modules/newNotifications";

export const TabButton = ({
  count,
  onClick,
  text,
  selected,
  className,
  styleType
}) => {
  const isYellow = styleType === NOTIFICATIONS_TAB_STYLES_TYPES.YELLOW;

  return (
    <button
      onClick={onClick}
      className={classNames(
        "bg-none b-none text-xs flex gap-1 align-center px-3 justify-center pt-2",
        className,
        {
          "text-black font-semibold border-bottom-1 border-bottom-black": selected,
          "text-black-5 font-medium border-bottom border-bottom-gray-1": !selected
        }
      )}
      style={selected ? { paddingBottom: 8 } : { paddingBottom: 8.5 }}
    >
      {count ? (
        <span
          className={classNames(
            "min-h-3.5 min-w-3.5 rounded-full text-white font-bold text-xs.2 flex align-center text-center justify-center bg-red-1 shrink-0"
          )}
        >
          {Math.min(count, 99)}
        </span>
      ) : null}
      {text ? (
        <div
          className={classNames({
            "py px-1.5 rounded": isYellow,
            "bg-yellow":
              NOTIFICATIONS_TAB_STYLES_TYPES.YELLOW === styleType && selected,
            "bg-yellow-2":
              NOTIFICATIONS_TAB_STYLES_TYPES.YELLOW === styleType && !selected
          })}
        >
          <span>{text}</span>
        </div>
      ) : null}
    </button>
  );
};
